/**
 * Retourne l'URL absolue du logo pour éviter les images cassées en production.
 * En production (même origine), /uploads/xxx doit être servi par le backend.
 */
export function getLogoUrl(url) {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin + url;
  }
  return url;
}
